import { Component } from '@angular/core';
import {
  DynamicFormField,
  fieldGroup,
  formBuilder,
  number,
  select,
} from '@kinet-open-network/client/core/forms/ui';
import {
  AutomationRuleOperator,
  IAutomationRule,
} from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';
import { RULE_TEMPLATE, RuleComponent } from './abstract-rule.component';

@Component({
  imports: [FormlyModule],
  selector: 'kon-overdue-invoice-date-rule',
  template: RULE_TEMPLATE,
})
export class OverdueInvoiceDateRuleComponent extends RuleComponent {
  override defaultModel: Partial<IAutomationRule> = {
    operator: AutomationRuleOperator.GreaterThan,
  };

  override fields: DynamicFormField[] = formBuilder(
    fieldGroup()
      .fieldGroupClassName(`grid grid-cols-3 gap-2`)
      .fieldGroup([
        this.ruleSelectField,
        select('operator')
          .options([
            {
              label: 'viac ako',
              value: AutomationRuleOperator.GreaterThan,
            },
            {
              label: 'viac alebo rovné ako',
              value: AutomationRuleOperator.GreaterThanOrEquals,
            },
          ])
          .wrappers([]),
        number('value', '').props({ min: 0 }).wrappers([]),
      ]),
  );
}
